<template>
  <div class="relative z-index-500 center-items-x pa-1 ml-3 mr-3 mt-3 pt-3">
    <div class="spacer"></div>

    <div class="medium title-2 mb-1 mr-1 mt-3 pt-3">
      Inicie Sesión con sus
      Credenciales
      <br />de
      Administrador
    </div>

    <form class="mr-2 mt-2 mb-1">
      <div class="medium normal">Correo Electrónico</div>
      <input
        v-model="payload.clientEmail"
        class="bizel border-line-2 height-50 border-line-2 reverse normal mb-1 pl-2"
        placeholder="admin@complex.com.co"
        type="email"
        autocomplete="email"
      />
      <div class="medium normal">Contraseña</div>
      <input
        v-model="payload.clientPassword"
        class="bizel border-line-2 height-50 border-input reverse normal pl-2"
        placeholder="* * * * *"
        type="password"
        autocomplete="new-password"
      />
      <div class="row mb-1">
        <div class="spacer"></div>
        <div
          @click.stop="$router.push('/reset')"
          class="body-2 pr-1 pl-1 medium isButton2"
        >¿Olvidó su contraseña?</div>
      </div>
    </form>

    <div @click.stop="login" class="mb-3 row medium uppercased normal">
      <div class="bizel back1 height-50 center-items theme pr-3 pl-3 col isButton">Iniciar sesión</div>
      <div class="spacer row"></div>
    </div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
  </div>
</template>
<script>
export default {
  data: () => ({
    payload: {
      clientEmail: "",
      clientPassword: ""
    }
  }),
  methods: {
    login() {
      if (this.payload.clientEmail != "" && this.payload.clientPassword != "") {
        this.$store.dispatch("login", this.payload);
      } else {
        this.$store.commit("messages", {
          visible: true,
          icon: "mdi-close",
          text: "El formulario contiene errores",
          color: "red"
        });
      }
    }
  }
};
</script>
